/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartPieA1Icon20Light = forwardRef('DataChartPieA1Icon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.5 2a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .75.433l6.062-3.5a.5.5 0 0 0 .183-.683A7.5 7.5 0 0 0 9.5 2Zm.5 6.634V3.019a6.5 6.5 0 0 1 4.863 2.808L10 8.634Z" }),
        React.createElement("path", { d: "M7.225 3.411a.5.5 0 1 0-.35-.937 7.5 7.5 0 1 0 10.047 5.95.5.5 0 0 0-.99.143 6.5 6.5 0 1 1-8.707-5.156Z" })));
});
